var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import View from '../../../elements/View';
import { Button, Text } from '../../../elements';
import theme, { padding } from '../../../Theme';
import { T } from '../../../helpers/i18n';
import { inject } from 'mobx-react';
import Theme from '../../../Theme';
import { Modal } from '../../../components';
import { FormGroup, Input, InputGroup, InputGroupAddon, Label } from 'reactstrap';
const init = {
    showModal: false,
    pass1: '',
    pass2: '',
    showPass1: false,
    showPass2: false,
    disabledPass1: false,
    disabledPass2: false
};
let Menu = class Menu extends Component {
    constructor() {
        super(...arguments);
        this.state = init;
        this.handleLogout = () => {
            if (confirm(T('closeSessionAsk'))) {
                this.props.store.users.logout();
            }
        };
        this.reset = () => {
            this.setState(init);
        };
        this.handleSave = () => {
            const disable = () => (this.setState({
                disabledPass1: true,
                disabledPass2: true
            }));
            const enable = () => (this.setState({
                disabledPass1: false,
                disabledPass2: false
            }));
            disable();
            if (this.state.pass1.length < 5) {
                enable();
                this.props.store.UI.newError('Contraseña no válida, debe tener al menos 5 caracteres');
                return;
            }
            if (this.state.pass1 !== this.state.pass2) {
                enable();
                this.props.store.UI.newError('Contraseñas no coinciden');
                return;
            }
            this.props.store.users.changePassword(this.state.pass1)
                .then(value => {
                this.setState(init);
                this.props.store.UI.newOk('Contraseña cambiada correctamente');
            })
                .catch(error => {
                console.log('error: ', error);
                this.setState({ disabledPass1: false, disabledPass2: false });
            });
        };
    }
    render() {
        var _a;
        const { username, client } = this.props.store.users.user;
        const barHeigh = theme.common.size.bar;
        const { showModal, pass1, pass2, showPass1, showPass2, disabledPass1, disabledPass2 } = this.state;
        const afiliateName = (_a = this.props.store.users.user.afiliate) === null || _a === void 0 ? void 0 : _a.name;
        return (React.createElement(View, null,
            React.createElement(View, { flex: true, center: true, row: true, style: {
                    width: '100%',
                    position: 'absolute',
                    top: `${barHeigh}px`,
                    flexWrap: 'wrap',
                    justifyContent: 'right',
                } },
                React.createElement(Button, { loading: 'post@logout', onClick: this.handleLogout, style: Object.assign(Object.assign({}, padding(1.5)), { borderRadius: 5, border: `2px solid ${Theme.color.primary}` }) }, T('closeSession'))),
            React.createElement(View, { style: Object.assign(Object.assign({}, padding(2)), { paddingBottom: 0 }) },
                React.createElement(Text, { small: true }, `${process.env.REACT_APP_VERSION}`)),
            React.createElement(View, { style: Object.assign(Object.assign({}, padding(2)), { paddingTop: 0 }) },
                React.createElement(Text, { small: true }, `Fecha build: ${process.env.REACT_APP_DATEBUILD}`)),
            React.createElement(View, { style: Object.assign({}, padding(1)) },
                React.createElement(Text, { style: { paddingLeft: 30, textAlign: 'start' } }, `${T('client')}: ${client}`)),
            React.createElement(View, { style: Object.assign({}, padding(1)) },
                React.createElement(Text, { style: { paddingLeft: 30, textAlign: 'start' } }, `${T('operario')}: ${username}`)),
            afiliateName && React.createElement(View, { style: Object.assign({}, padding(1)) },
                React.createElement(Text, { style: { paddingLeft: 30, textAlign: 'start' } }, `${T('afiliate')}: ${afiliateName}`)),
            React.createElement(View, { style: Object.assign({}, padding(1)) },
                React.createElement(Button, { onClick: () => this.setState({ showModal: true }) }, "Cambiar contrase\u00F1a")),
            showModal && React.createElement(Modal, { title: 'cambiar contraseña' },
                React.createElement(View, { style: {
                        padding: '20px'
                    } },
                    React.createElement("div", null,
                        React.createElement(FormGroup, null,
                            React.createElement(Label, { for: 'examplePassword' }, "Password"),
                            React.createElement(InputGroup, null,
                                React.createElement(Input, { id: 'pass1', name: 'pass1', value: pass1, disabled: disabledPass1, type: showPass1 ? 'text' : 'password', placeholder: 'contraseña', onChange: event => {
                                        this.setState({ pass1: event.target.value });
                                    } }),
                                React.createElement(Button, { onClick: () => {
                                        this.setState((prev) => {
                                            return { showPass1: !prev.showPass1 };
                                        });
                                    } }, "Mostrar")),
                            React.createElement(InputGroup, null,
                                React.createElement(Input, { id: 'pass2', name: 'pass2', value: pass2, disabled: disabledPass2, type: this.state.showPass2 ? 'text' : 'password', placeholder: 'repeat contraseña', onChange: (event) => this.setState({ pass2: event.target.value }) }),
                                React.createElement(InputGroupAddon, { addonType: 'append' },
                                    React.createElement(Button, { onClick: () => {
                                            this.setState((prev) => ({ showPass2: !prev.showPass2 }));
                                        } }, "Mostrar")))),
                        React.createElement(View, { flex: true, row: true, style: {
                                justifyContent: 'space-around'
                            } },
                            React.createElement(Button, { onClick: this.handleSave }, "Guardar"),
                            React.createElement(Button, { onClick: () => {
                                    this.setState(init);
                                } }, "Salir")))))));
    }
};
Menu = __decorate([
    inject('store')
], Menu);
export default Menu;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Menu/container/Menu.tsx
// module id = 545
// module chunks = 0